"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComparisonTypeDropdownComponent = exports.ComparisonType = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var configurationStyles_1 = require("../configurationStyles");
/**
 * This should be in the engine's models, right?
 */
var ComparisonType;
(function (ComparisonType) {
    ComparisonType["HISTORICAL"] = "HISTORICAL";
    ComparisonType["CONSTANT"] = "CONSTANT";
})(ComparisonType = exports.ComparisonType || (exports.ComparisonType = {}));
var isComparisonType = function (input) {
    return Object.keys(ComparisonType).indexOf(input) !== -1;
};
var ComparisonTypeDropdownComponent = function (props) {
    var _a;
    var listItems = [
        {
            content: historicalComparisonDisplayText((_a = props.canAuthorHistoricalComparison) !== null && _a !== void 0 ? _a : false),
            value: ComparisonType.HISTORICAL,
        },
        {
            content: Localize_1.Messages.ConstantComparison(),
            value: ComparisonType.CONSTANT,
        },
    ];
    var handleChange = function (type) {
        if (type !== props.selectedComparisonType) {
            if (isComparisonType(type)) {
                props.onComparisonChange(type);
            }
        }
    };
    return (React.createElement(widgets_1.SingleSelectDropdown, { className: configurationStyles_1.inputSection, testId: props.testId, type: widgets_1.DropdownButtonType.Outline, label: Localize_1.Messages.ComparisonTypeLabel(), list: React.createElement(widgets_1.List, { items: listItems }), onChange: handleChange, value: props.selectedComparisonType, disabled: props.disabled, buttonRef: props.dropdownRef }));
};
exports.ComparisonTypeDropdownComponent = ComparisonTypeDropdownComponent;
// TFS1349399: For metrics without a date dimension (and without snapshotting), it's an odd
// experience to choose "Historical" and not have any other inputs or any reason why. We've
// chosen to change the label for this option but NOT persist things differently.
function historicalComparisonDisplayText(canAuthorHistoricalComparison) {
    return canAuthorHistoricalComparison ? Localize_1.Messages.HistoricalComparison() : Localize_1.Messages.NoComparison();
}
//# sourceMappingURL=ComparisonTypeDropdown.js.map